<template>
    <a :href="url">Connect to YouTube</a>
</template>

<script>

import api from "../services/apiEndpoints.js";

export default {
    name: "VideoTemp",
    data: function(){
        return {
            url: ""
        }
    },
    mounted: function(){
        this.$http.get(api.actions.get_code_url).then((res) => {
            this.url = res.data.url;
        });
    }
}

</script>